import type { JSONContent } from '@tiptap/core';

const updateText = (node: JSONContent, newText: string) => {
  return {
    ...node,
    content: node.content?.map((contentItem: JSONContent) => ({
      ...contentItem,
      text: newText,
    })),
  };
};

export const extractDateFromISOString = (timestamp: string) => {
  try {
    return timestamp?.match(/(\d{4}-\d{2}-\d{2})/g)?.[0] || timestamp;
  } catch {
    // do nothing
  }

  return timestamp;
};

const formatPostTime = (postTimeISO: string, style: string) => {
  const postTime = new Date(postTimeISO);

  // Handle different styles
  switch (style) {
    case 'short_date':
      return postTime.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    case 'numeric_date':
      return postTime.toLocaleDateString('en-US');
    case 'iso_date':
      return postTime.toISOString().split('T')[0]; // ISO format
    case 'day_first':
      return postTime.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    case 'month_year':
      return postTime.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
      });
    default:
      // Fallback to a standard format if the style is unknown
      return postTime.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      });
  }
};

export { updateText, formatPostTime };
